/* ==========================================================================
   Filament365 — search.js
   Shopify Predictive Search (Section Rendering ile).
   - Açılır arama paneli, yazarken öneri
   - Klavye gezinmesi (ok tuşları, Enter, Esc), ekran okuyucu duyuruları
   - İstekler iptal edilir (eski sonuç yeni sonucun üstüne yazmaz)
   ========================================================================== */
(function () {
  'use strict';

  var S = window.themeStrings || {};
  var T = window.themeSettings || { routes: {} };
  var F = window.F365;

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.input = this.querySelector('input[type="search"]');
      this.form = this.querySelector('form');
      this.results = this.querySelector('[data-results]');
      this.clearBtn = this.querySelector('button[type="reset"]');
      this.backdrop = document.querySelector('[data-search-backdrop]');
      this.defaultContent = this.results.innerHTML;
      this.cache = new Map();
      this.controller = null;
      this.activeIndex = -1;
      this.opener = null;

      this.minLength = 2;

      document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-open-search]');
        if (opener) { e.preventDefault(); self.isOpen ? self.close() : self.open(opener); return; }
        if (e.target.closest('[data-close-search]')) { self.close(); return; }
        if (self.isOpen && e.target === self.backdrop) self.close();
      });

      this.input.addEventListener('input', F.debounce(function () { self.onInput(); }, 220));
      this.input.addEventListener('input', function () {
        if (self.clearBtn) self.clearBtn.hidden = !self.input.value;
      });
      this.input.addEventListener('keydown', function (e) { self.onKeydown(e); });
      this.form.addEventListener('reset', function () {
        setTimeout(function () {
          self.showDefault();
          self.input.focus();
          if (self.clearBtn) self.clearBtn.hidden = true;
        }, 0);
      });
      this.form.addEventListener('submit', function (e) {
        // Aktif bir öneri seçiliyse oraya git
        var active = self.activeOption();
        if (active) {
          e.preventDefault();
          window.location.href = active.getAttribute('href');
        } else if (!self.input.value.trim()) {
          e.preventDefault();
          self.input.focus();
        }
      });

      this.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.stopPropagation(); self.close(true); }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.isOpen) self.close(true);
      });
    }

    get isOpen() { return !this.hidden; }

    open(opener) {
      this.opener = opener || null;
      this.hidden = false;
      if (this.backdrop) this.backdrop.hidden = false;
      document.querySelectorAll('[data-open-search]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var self = this;
      requestAnimationFrame(function () {
        self.classList.add('is-open');
        if (self.backdrop) self.backdrop.classList.add('is-open');
        self.input.focus();
      });
    }

    close(restoreFocus) {
      if (this.hidden) return;
      this.classList.remove('is-open');
      if (this.backdrop) this.backdrop.classList.remove('is-open');
      document.querySelectorAll('[data-open-search]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      var self = this;
      setTimeout(function () {
        if (!self.classList.contains('is-open')) {
          self.hidden = true;
          if (self.backdrop) self.backdrop.hidden = true;
        }
      }, F.reducedMotion ? 0 : 220);
      this.input.setAttribute('aria-expanded', 'false');
      if (restoreFocus && this.opener && document.contains(this.opener)) this.opener.focus();
    }

    showDefault() {
      if (this.controller) this.controller.abort();
      this.results.innerHTML = this.defaultContent;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.activeIndex = -1;
    }

    onInput() {
      var term = this.input.value.trim();
      if (term.length < this.minLength) {
        this.showDefault();
        return;
      }
      this.fetchResults(term);
    }

    fetchResults(term) {
      var self = this;
      var key = term.toLowerCase();
      if (this.cache.has(key)) { this.render(this.cache.get(key)); return; }

      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.results.setAttribute('aria-busy', 'true');
      this.results.classList.add('is-loading');

      var url = T.routes.searchSuggest +
        '?q=' + encodeURIComponent(term) +
        '&section_id=predictive-search' +
        '&resources[type]=product,collection,query' +
        '&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor,tag';

      fetch(url, { signal: this.controller.signal, credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('search');
          return res.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var root = doc.querySelector('[data-ps-root]');
          var html = root ? root.outerHTML : '';
          self.cache.set(key, html);
          self.render(html);
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          self.results.classList.remove('is-loading');
          self.results.removeAttribute('aria-busy');
        });
    }

    render(html) {
      this.results.innerHTML = html || this.defaultContent;
      this.results.classList.remove('is-loading');
      this.results.removeAttribute('aria-busy');
      this.activeIndex = -1;
      this.input.removeAttribute('aria-activedescendant');
      var hasOptions = this.options().length > 0;
      this.input.setAttribute('aria-expanded', hasOptions ? 'true' : 'false');
      var status = this.results.querySelector('[data-ps-status]');
      if (status) F.announce(status.textContent.trim());
    }

    options() {
      return Array.prototype.slice.call(this.results.querySelectorAll('[role="option"]'));
    }

    activeOption() {
      var opts = this.options();
      return this.activeIndex > -1 ? opts[this.activeIndex] : null;
    }

    setActive(i) {
      var opts = this.options();
      if (!opts.length) return;
      opts.forEach(function (o) { o.classList.remove('is-active'); o.removeAttribute('aria-selected'); });
      this.activeIndex = (i + opts.length) % opts.length;
      var el = opts[this.activeIndex];
      el.classList.add('is-active');
      el.setAttribute('aria-selected', 'true');
      this.input.setAttribute('aria-activedescendant', el.id);
      el.scrollIntoView({ block: 'nearest' });
    }

    onKeydown(e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); this.setActive(this.activeIndex + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); this.setActive(this.activeIndex - 1); }
    }
  }
  customElements.define('predictive-search', PredictiveSearch);
})();
